// Source: app/scripts/directives/html-field.js
/*
 * Directive for generic combo (select)
 *
 */

Auction.directive('htmlField', [
  'crudService',
  'settings',
  function(crudService, settings) {
    return {
      restrict: 'E',
      templateUrl: 'directives/htmlField.html',
      scope: {
        fProperties: '@',
        fEntity: '=',
        /**
         * The label for translating entity name
         */
        fLabel: '@',
        /**
         * The name of the field
         */
        ifName: '@',
        /**
         * whether the field is required or not
         */
        ifRequired: '=',

        /**
         * the model of the field
         */
        fModel: '='
          /**
           * The fields that start with <b>if-</b> will be copied to the input
           * element, without the <b>if-</b> part
           */
      },
      compile: function(tElem, attrs) {
        if (!attrs['fLabel']) {
          attrs['fLabel'] = settings.translationPrefix + attrs['ifName'];
        }

        return function(scope, element, attrs, ctrl, transclude, formCtrl) {
          var baseClass = scope.baseClass || "form-group";

          scope.form = element.parent().controller('form');
          scope.fName = attrs.ifName;
          scope.fType = attrs.ifType;
          scope.message = attrs.message || 'generic.required';
          scope.validationParams = attrs;
        };
      },
      controller: function($scope, $element) {
        $scope.$watch('fEntity', function(n, o) {
          if (n === o || !n) return;
          $scope.propertiesField = $scope.fProperties || $scope.ifName;
          $scope.fieldProperties = n.fieldProperties;
        });

        $scope.propertiesField = $scope.fProperties || $scope.ifName;
        $scope.fieldProperties = $scope.fEntity.fieldProperties;

      }
    };
  }
]);